import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
    Box, Button, Container, Flex, Heading, Stack, Text, useColorModeValue,
} from '@chakra-ui/react';

const FRAUD_WORDS = [
  "Scams",
  "Fraud",
  "Penipuan", // Indonesian
  "Estafa", // Spanish
  "Arnaque", // French
  "诈骗", // Chinese
  "Мошенничество", // Russian
  "Dolandırıcılık", // Turkish
  "Truffa", // Italian
  "Betrug", // German
  "Golpe", // Portuguese
  "Bedrog", // Dutch
  "사기", // Korean
  "詐欺", // Japanese
  "Swindle",
  "Rip-off",
  "Cheat",
  "Hoax",
  "Deception",
  "Con",
  "Ripdeal",
];

export default function Landing() {
  const [fraudWordIndex, setFraudWordIndex] = useState(0);
  const highlightColor = useColorModeValue("purple.400", "purple.300");
  const orangeColor = useColorModeValue("orange.400", "orange.300");
  const bg = useColorModeValue("gray.50", "gray.900");

  useEffect(() => {
    const interval = setInterval(() => {
      setFraudWordIndex((i) => (i + 1) % FRAUD_WORDS.length);
    }, 1200);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box minH="100vh" bg={bg}>
      <Container maxW="2xl" centerContent py={24}>
        <Stack spacing={6} align="center" w="full">
          <Flex align="center" gap={2}></Flex>
          <Heading
            as="h1"
            textAlign="center"
            fontSize={{ base: "2xl", md: "4xl", lg: "6xl" }}
            fontWeight={700}
            lineHeight={1.2}
          >
            Spot{" "}
            <Box as="span" color={highlightColor} transition="color 0.3s">
              {FRAUD_WORDS[fraudWordIndex]}
            </Box>{" "}
            And{" "}
            <Box as="span" color={orangeColor}>
              Protect
            </Box>{" "}
            <Box as="span" color={highlightColor}>
              Yourself
            </Box>{" "}
            Before They Spot You
          </Heading>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.500"
            textAlign="center"
            maxW="2xl"
          >
            Fraudo helps you verify accounts and report fraudulent activities.
            Stay one step ahead of scammers with our comprehensive fraud
            prevention platform.
          </Text>
          <Stack
            direction={{ base: "column", sm: "row" }}
            spacing={4}
            pt={2}
            w="full"
            justify="center"
          >
            <Button
              as={RouterLink}
              to="/check"
              size="lg"
              colorScheme="blue"
              px={8}
            >
              Check Account
            </Button>
            <Button
              as={RouterLink}
              to="/report"
              size="lg"
              variant="outline"
              px={8}
            >
              Report Fraud
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
